import Fetch from "./Fetch";
import { handleError, handleResponse } from "./ApiUtils";

import { API_BASIC_URL_USER_MANAGEMENT } from "../config/constants";

export const getAllUserRoleTypes = () => {
  return Fetch.get(`${API_BASIC_URL_USER_MANAGEMENT}/api/v1/roles`).then(handleResponse).catch(handleError);
};
